var _circle, _rect, _rect2, _mask, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#FF6565"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_964_6183)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.755,
    y: 21.0968,
    width: 87.5523,
    height: 182.757,
    rx: 14.9849,
    fill: "#005537",
    stroke: "#005537",
    strokeWidth: 0.198475
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7061,
    y: 24.0469,
    width: 81.6523,
    height: 176.857,
    rx: 11.9085,
    fill: "#FFFBDB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_964_6183",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4753 24.3604C57.7944 24.6212 58.0183 25.0107 58.0183 25.4001L58.0183 25.0613L58.0183 24.5146C58.0655 27.6313 60.6067 30.1434 63.7347 30.1434L95.3289 30.1434C98.4522 30.1434 100.99 27.639 101.045 24.5288L101.045 25.2307C101.045 24.8793 101.182 24.5734 101.408 24.3604C107.855 24.3607 111.12 24.3823 113.624 25.6583C115.865 26.8 117.687 28.6218 118.828 30.8625C120.126 33.4099 120.126 36.7446 120.126 43.414L120.126 182.164C120.126 188.833 120.126 192.168 118.828 194.715C117.687 196.956 115.865 198.778 113.624 199.919C111.077 201.217 107.742 201.217 101.073 201.217L57.5278 201.217C50.8584 201.217 47.5237 201.217 44.9763 199.919C42.7356 198.778 40.9138 196.956 39.7721 194.715C38.4741 192.168 38.4741 188.833 38.4741 182.164L38.4741 43.414C38.4741 36.7446 38.4741 33.4099 39.7721 30.8625C40.9138 28.6218 42.7356 26.8 44.9763 25.6583C47.517 24.3638 50.8409 24.3604 57.4753 24.3604Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M57.4753 24.3604L58.4724 23.1405L58.0373 22.7848L57.4753 22.7848L57.4753 24.3604ZM58.0183 24.5146L59.5937 24.4907L56.4428 24.5146L58.0183 24.5146ZM101.045 24.5288L102.621 24.5288L99.4699 24.5011L101.045 24.5288ZM101.408 24.3604L101.408 22.7848L100.783 22.7848L100.328 23.2135L101.408 24.3604ZM113.624 25.6583L112.909 27.0621L112.909 27.0621L113.624 25.6583ZM118.828 30.8625L117.425 31.5778L117.425 31.5778L118.828 30.8625ZM120.126 43.414L118.551 43.414L120.126 43.414ZM120.126 182.164L121.702 182.164L120.126 182.164ZM118.828 194.715L117.425 194L117.425 194L118.828 194.715ZM113.624 199.919L112.909 198.515L112.909 198.515L113.624 199.919ZM44.9763 199.919L45.6916 198.515L45.6916 198.515L44.9763 199.919ZM39.7721 194.715L41.1759 194L41.1759 194L39.7721 194.715ZM38.4741 182.164L40.0496 182.164L38.4741 182.164ZM38.4741 43.414L36.8986 43.414L38.4741 43.414ZM39.7721 30.8625L38.3683 30.1472L39.7721 30.8625ZM44.9763 25.6583L44.261 24.2545L44.261 24.2545L44.9763 25.6583ZM56.4783 25.5802C56.4845 25.5853 56.4844 25.5886 56.4782 25.5769C56.4721 25.5656 56.4428 25.5063 56.4428 25.4001L59.5938 25.4001C59.5938 24.4285 59.0636 23.6237 58.4724 23.1405L56.4783 25.5802ZM59.5938 25.4001L59.5938 25.0613L56.4428 25.0613L56.4428 25.4001L59.5938 25.4001ZM59.5938 25.0613L59.5938 24.5146L56.4428 24.5146L56.4428 25.0613L59.5938 25.0613ZM56.443 24.5384C56.5031 28.5146 59.7446 31.719 63.7347 31.719L63.7347 28.5679C61.4689 28.5679 59.6278 26.7481 59.5937 24.4907L56.443 24.5384ZM63.7347 31.719L95.3289 31.719L95.3289 28.5679L63.7347 28.5679L63.7347 31.719ZM95.3289 31.719C99.313 31.719 102.551 28.5244 102.62 24.5565L99.4699 24.5011C99.4303 26.7536 97.5913 28.5679 95.3289 28.5679L95.3289 31.719ZM99.4696 24.5288L99.4696 25.2307L102.621 25.2307L102.621 24.5288L99.4696 24.5288ZM102.621 25.2307C102.621 25.2997 102.588 25.4132 102.488 25.5072L100.328 23.2135C99.7756 23.7336 99.4696 24.4589 99.4696 25.2307L102.621 25.2307ZM101.408 25.9359C104.655 25.9361 107.007 25.9428 108.861 26.1008C110.696 26.2572 111.912 26.554 112.909 27.0621L114.34 24.2545C112.832 23.4866 111.163 23.1346 109.128 22.9611C107.112 22.7892 104.608 22.785 101.408 22.7848L101.408 25.9359ZM112.909 27.0621C114.853 28.0528 116.434 29.6335 117.425 31.5778L120.232 30.1472C118.94 27.6101 116.877 25.5473 114.34 24.2545L112.909 27.0621ZM117.425 31.5778C117.942 32.5924 118.24 33.8324 118.394 35.7208C118.55 37.6275 118.551 40.0533 118.551 43.414L121.702 43.414C121.702 40.1053 121.703 37.529 121.534 35.4642C121.364 33.381 121.013 31.6801 120.232 30.1472L117.425 31.5778ZM118.551 43.414L118.551 182.164L121.702 182.164L121.702 43.414L118.551 43.414ZM118.551 182.164C118.551 185.524 118.55 187.95 118.394 189.857C118.24 191.745 117.942 192.985 117.425 194L120.232 195.43C121.013 193.897 121.364 192.197 121.534 190.113C121.703 188.049 121.702 185.472 121.702 182.164L118.551 182.164ZM117.425 194C116.434 195.944 114.853 197.525 112.909 198.515L114.34 201.323C116.877 200.03 118.94 197.967 120.232 195.43L117.425 194ZM112.909 198.515C111.894 199.032 110.654 199.33 108.766 199.485C106.859 199.64 104.434 199.642 101.073 199.642L101.073 202.793C104.382 202.793 106.958 202.794 109.023 202.625C111.106 202.455 112.807 202.104 114.34 201.323L112.909 198.515ZM101.073 199.642L57.5278 199.642L57.5278 202.793L101.073 202.793L101.073 199.642ZM57.5278 199.642C54.1671 199.642 51.7413 199.64 49.8346 199.485C47.9462 199.33 46.7061 199.032 45.6916 198.515L44.261 201.323C45.7938 202.104 47.4948 202.455 49.578 202.625C51.6428 202.794 54.2191 202.793 57.5278 202.793L57.5278 199.642ZM45.6916 198.515C43.7473 197.525 42.1665 195.944 41.1759 194L38.3683 195.43C39.661 197.967 41.7238 200.03 44.261 201.323L45.6916 198.515ZM41.1759 194C40.6589 192.985 40.3609 191.745 40.2067 189.857C40.0509 187.95 40.0496 185.524 40.0496 182.164L36.8986 182.164C36.8986 185.472 36.8974 188.049 37.0661 190.113C37.2363 192.197 37.5873 193.897 38.3683 195.43L41.1759 194ZM40.0496 182.164L40.0496 43.414L36.8986 43.414L36.8986 182.164L40.0496 182.164ZM40.0496 43.414C40.0496 40.0533 40.0509 37.6275 40.2067 35.7208C40.3609 33.8324 40.6589 32.5924 41.1759 31.5778L38.3683 30.1472C37.5873 31.6801 37.2363 33.381 37.0661 35.4642C36.8974 37.529 36.8986 40.1053 36.8986 43.414L40.0496 43.414ZM41.1759 31.5778C42.1665 29.6335 43.7473 28.0528 45.6916 27.0621L44.261 24.2545C41.7238 25.5473 39.661 27.6101 38.3683 30.1472L41.1759 31.5778ZM45.6916 27.0621C46.7034 26.5465 47.9397 26.2487 49.8198 26.0941C51.7182 25.938 54.1325 25.9359 57.4754 25.9359L57.4753 22.7848C54.1837 22.7848 51.6188 22.7845 49.5615 22.9537C47.4858 23.1244 45.7898 23.4755 44.261 24.2545L45.6916 27.0621Z",
    fill: "#005537",
    style: {
      mixBlendMode: "overlay"
    },
    mask: "url(#path-4-inside-1_964_6183)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_964_6183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.471 85.4023L63.7517 85.4023L63.8068 92.1214L70.5261 92.1214L70.471 85.4023Z",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6635 108.92L63.9442 108.92L63.9993 115.639L70.7186 115.639L70.6635 108.92Z",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9882 85.4028L87.2689 85.4028L87.324 92.1219L94.0433 92.1219L93.9882 85.4028Z",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8887 102.201L77.3272 102.201L77.3548 105.561",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0745 105.561L84.1571 115.639L94.236 115.639L94.1534 105.561L90.7937 105.561",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4106 112.279L77.4382 115.638",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1904 85.4033L77.2731 95.4819L80.6327 95.4819",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3801 98.8418L94.0994 98.8418",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6858 87.083L53.6169 78.6842C53.6096 77.7932 53.9566 76.9387 54.5814 76.3087C55.2063 75.6787 56.058 75.3247 56.949 75.3247L65.3481 75.3247",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2266 75.3247L100.626 75.3247C101.517 75.3247 102.374 75.6787 103.009 76.3087C103.645 76.9387 104.006 77.7932 104.013 78.6842L104.082 87.083",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.303 113.96L104.372 122.359C104.379 123.25 104.032 124.104 103.407 124.734C102.782 125.364 101.931 125.718 101.039 125.718L92.6404 125.718",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7611 125.717L57.362 125.717C56.4709 125.717 55.6135 125.363 54.9783 124.733C54.3431 124.103 53.9821 123.249 53.9748 122.358L53.9059 113.959",
    stroke: "#005537",
    strokeWidth: 3.17784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0178 22.9863L101.046 22.9863L101.046 24.0508L102.231 24.0508C101.554 24.0508 101.046 24.559 101.046 25.2366L101.046 24.5125C101.003 27.6332 98.4599 30.1498 95.3291 30.1498L63.7349 30.1498C60.5774 30.1498 58.0178 27.5901 58.0178 24.4327L58.0178 22.9863ZM56.6624 24.0508C57.34 24.0508 58.0176 24.7284 58.0176 25.406L58.0176 25.0672L58.0176 24.0508L56.6624 24.0508Z",
    fill: "#005537"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_964_6183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 139.002,
    fill: "white",
    transform: "translate(35.9998 20.9976)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_964_6183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.2559,
    height: 55.8001,
    fill: "white",
    transform: "matrix(1 4.19106e-10 0.00820296 0.999966 51.4917 72.1211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeError);
export default __webpack_public_path__ + "static/media/qr_code_error.df883f30dcb05cffcaeef7da63d43674.svg";
export { ForwardRef as ReactComponent };